import { render, staticRenderFns } from "./quickMitsumoriUser.vue?vue&type=template&id=5bec4a8a&"
import script from "./quickMitsumoriUser.vue?vue&type=script&lang=ts&"
export * from "./quickMitsumoriUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports